module.exports = __webpack_public_path__ + "static/media/MK 21.c9946f3d.mp3";